{"NG_APP_API_URL":"https://trustchecker.fixa.by/api","NG_APP_PRODUCTION":"true","NG_APP_WEBSOCKET_URL":"wss://trustchecker.fixa.by/api/ws"}